import PropTypes from 'prop-types'

const classnames = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.bool)
  ])),
  PropTypes.objectOf(PropTypes.bool)
])

const style = PropTypes.objectOf(PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
]))

const tag = PropTypes.oneOfType([
  PropTypes.shape({ $$typeof: PropTypes.symbol, render: PropTypes.func }),
  PropTypes.func,
  PropTypes.node
])

const children = PropTypes.oneOfType([
  tag,
  PropTypes.arrayOf(tag)
])

const jobId = PropTypes.oneOfType([PropTypes.string, PropTypes.number])

const companyId = PropTypes.number

export default {
  children,
  classnames,
  companyId,
  jobId,
  style,
  tag
}
